// extracted by mini-css-extract-plugin
export default {"row":"DpBottomButtons_row__rPUjj","button":"DpBottomButtons_button__GTR-l"};